import React from 'react';
import { clsx} from 'clsx';
import { twMerge} from 'tailwind-merge';

/**
 * Utility for merging tailwind classes properly
 */
function cn(...inputs) {
 return twMerge(clsx(inputs));
}

const variants = {
 primary: 'bg-[rgba(1,118,211,0.1)] text-[#0176D3] border-[rgba(1,118,211,0.15)]',
 success: 'bg-[rgba(4,132,75,0.1)] text-[#04844b] border-[rgba(4,132,75,0.15)]',
 danger: 'bg-[rgba(186,5,23,0.1)] text-[#BA0517] border-[rgba(186,5,23,0.15)]',
 warning: 'bg-[rgba(254,147,57,0.12)] text-[#DD7A01] border-[rgba(254,147,57,0.25)]',
 secondary: 'bg-[#F3F2F2] text-[#706E6B] border-[#D8DDE6]',
 slate: 'bg-[#F3F2F2] text-[#706E6B] border-[#D8DDE6]',
 blue: 'bg-[rgba(1,118,211,0.1)] text-[#0176D3] border-[rgba(1,118,211,0.2)]',
 emerald: 'bg-[rgba(4,132,75,0.1)] text-[#04844B] border-[rgba(4,132,75,0.2)]',
 rose: 'bg-[rgba(186,5,23,0.1)] text-[#BA0517] border-[rgba(186,5,23,0.2)]',
 amber: 'bg-[rgba(255,183,93,0.18)] text-[#B75D00] border-[rgba(255,183,93,0.3)]',
};

const Badge = ({ className, variant = 'slate', children, ...props}) => {
 return (
 <span
 className={cn(
 "inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border backdrop-blur-sm shadow-sm",
 variants[variant],
 className
 )}
 {...props}
 >
 {children}
 </span>
 );
};

export default Badge;

export { Badge};
